import { useAuth } from '@/context/AuthContext';
import useSignOut from '@/context/useSignOut';
import { cn } from '@/utils/utils';
import Balancer from 'react-wrap-balancer';
import { useIsPublicChat } from '../Chat/useIsPublicChat';
import type { OnboardingStep } from '../Modals/Onboarding/onboarding-modal';

const OnboardingFooter = ({
  variant,
}: {
  variant: OnboardingStep;
}) => {
  const { user } = useAuth();
  const { signOut } = useSignOut();

  const isPublicChat = useIsPublicChat();

  const handleLoginWithAnotherEmail = async () => {
    // Function to handle login with another email
    signOut('/login');
  };

  switch (variant) {
    case 'legal':
      return (
        <div
          className={cn(
            'flex flex-col items-center justify-center py-5 text-textGray3 w-64 text-center',
            !isPublicChat && 'fixed bottom-0',
          )}
        >
          <span className="text-sm text-gray-600">
            <Balancer>
              By continuing, you agree to Anara’s{' '}
              <a
                href="/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-black transition-all duration-150 ease-in underline"
              >
                Terms
              </a>{' '}
              and{' '}
              <a
                href="/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-black transition-all duration-150 ease-in underline"
              >
                Privacy Policy
              </a>
              .
            </Balancer>
          </span>
        </div>
      );
    case 'purpose':
    case 'referral':
      return (
        <div
          className={cn(
            'flex flex-col items-center justify-center py-5 text-textGray4 w-120 text-center text-sm',
          )}
        >
          <span className="mb-1">
            Continuing as <span className="font-semibold">
              {user?.email}
            </span>{' '}
          </span>

          <span>
            Log in with another email{' '}
            <a
              href="#"
              onClick={handleLoginWithAnotherEmail}
              className="hover:text-black transition-all duration-150 ease-in underline"
            >
              here
            </a>
          </span>
        </div>
      );
    default:
      return null;
  }
};

export default OnboardingFooter;
